module.exports = __webpack_public_path__ + "media/src/assets/leaf-background-1ccb8a313ef9119ec9b25010a06cfd94.png";